import { defineMessages } from 'react-intl';

export default defineMessages({
    errorMessageHeader: {
        id: 'rollover.errorMessageHeader',
        defaultMessage: 'Oops, something went wrong'
    },
    errorMessageBody: {
        id: 'rollover.errorMessageBody',
        defaultMessage: 'Please try uploading your file again.'
    },
    somethingWentWrong: {
        id: 'rollover.somethingWentWrong',
        defaultMessage: 'Something went wrong on our side and we are working on it.'
    },
    pleaseTryAgain: {
        id: 'rollover.pleaseTryAgain',
        defaultMessage: 'Please try again later or contact Tech Support'
    }
});



// WEBPACK FOOTER //
// ./app/containers/roll-over/messages.js